import React from "react";
import * as Sentry from "@sentry/react";
import { Flex, Text } from "styles/utility-components";

import Button from "components/ui/button/Button";
import Modal from "components/ui/modal/Modal";
import toast from "components/ui/toast/Toast";

export type ExportType = "pdf" | "docx";

interface ExportModalProps {
  isOpen: boolean;
  onClose: () => void;
  onExport: (filename: string, exportType: ExportType) => Promise<void>;
  exportType: ExportType;
  filename: string;
}

export default function ExportModal({
  isOpen,
  onClose,
  onExport,
  exportType,
  filename,
}: ExportModalProps) {
  const [isExporting, setIsExporting] = React.useState(false);

  const fileExtension = exportType === "pdf" ? "PDF" : "Word (.docx)";

  const handleExport = async () => {
    try {
      setIsExporting(true);
      await onExport(filename, exportType);
      toast.success(`${fileExtension} exported successfully`);
      onClose();
    } catch (error) {
      toast.error(`Failed to export ${fileExtension.toLowerCase()}`);
      Sentry.captureException(error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Modal open={isOpen} onOpenChange={onClose} showCloseButton={false}>
      <Flex flexDirection="column" gap={16} style={{ width: 432, padding: 16 }}>
        <Flex flexDirection="column" gap={8}>
          <Text h3>Export with images not yet supported</Text>

          <Text color="sysTextSecondary">Continue export without images?</Text>
        </Flex>

        <Flex justifyContent="flex-end" gap={8}>
          <Button buttonType="secondary" onClick={onClose} disabled={isExporting}>
            Cancel
          </Button>
          <Button
            buttonType="primary"
            onClick={handleExport}
            disabled={isExporting}
            loading={isExporting}
          >
            Export anyway
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}
